export default "__VITE_ASSET__BzYY6EKz__"